/** @format */

import PairingModelActionTypes from './pairing-model.types';

const INITIAL_STATE = {
  parameters: {
    // The following are the default values for the parameters
    // that will be used in the pairing model.
    fivep: 0,
    swapp: 0,
    reaqlswapp: 0,
    start_hour_penalty: 10,
    hour_penalty: 100,
    waste_penalty: 100,
    waste_hour_penalty: 4,
    crewcost: 1300,
    layovercost: 650,
    unpair_cost: 3500,
    soft_cap_cost: 1200,
    start_date: undefined, //YYYY-mm-dd
    end_date: undefined, //YYYY-mm-dd
    name: '',
  },
  crew_count: {
    BUR: 0,
    DAL: 0,
    HOU: 0,
    LAS: 0,
    MCO: 0,
    MIA: 0,
    OAK: 0,
    PHX: 0,
    SNA: 0,
  },
  error: undefined,
  runtime: undefined, //in seconds
  loading: false,
  availableModels: [],
  selectedModel: undefined,
  selectedModelData: undefined,
  selectedModelDetails: undefined,
};

const pairingModelReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PairingModelActionTypes.SET_PAIRING_MODEL_PARAMETERS:
      return {
        ...state,
        parameters: { ...state.parameters, ...action.payload },
      };

    case PairingModelActionTypes.SET_PAIRING_MODEL_CREW_COUNT:
      return {
        ...state,
        crew_count: { ...state.crew_count, ...action.payload },
      };

    case PairingModelActionTypes.SET_PAIRING_MODEL_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case PairingModelActionTypes.SET_PAIRING_MODEL_RUNTIME:
      return {
        ...state,
        runtime: action.payload,
      };

    case PairingModelActionTypes.SET_PAIRING_MODEL_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case PairingModelActionTypes.SET_SELECTED_PAIRING_MODEL:
      return {
        ...state,
        selectedModel: action.payload,
      };

    case PairingModelActionTypes.GET_PAIRING_MODEL_AVAILABLE_MODELS_SUCCESS:
      return {
        ...state,
        availableModels: action.payload,
      };

    case PairingModelActionTypes.GET_SELECTED_PAIRING_MODEL_DATA_SUCCESS:
      return {
        ...state,
        selectedModelData: action.payload.viz,
        selectedModelDetails: action.payload.details,
      };

    case PairingModelActionTypes.CLEAR_SELECTED_PAIRING_MODEL_DATA:
      return {
        ...state,
        selectedModelData: undefined,
        selectedModelDetails: undefined,
      };
    default:
      return state;
  }
};

export default pairingModelReducer;
